var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('Error'):_c('div',{class:{
    tickets: !_vm.active_breakpoint.is_mobile,
    'tickets--mobile': _vm.active_breakpoint.is_mobile,
  }},[(_vm.$route && _vm.$route.meta.is_monitor && _vm.profileRemote)?_c('banner-supervisor',{attrs:{"id":"stripeSection","profile":_vm.profileRemote}}):_vm._e(),_c('TicketsTemplate',{class:{ 'height-banner': _vm.$route.meta.is_monitor }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }